module.exports = __webpack_public_path__ + "img/trash-bin.04efd65a.svg";